import { React, useState, useRef } from "react";
import { useParams } from "react-router-dom"; 
import moment from "moment";


import CricketScoreBoard from "./CricketScoreBoard";
import FootBallScoreBoard from "./FootballScoreBoard";
import TennisScoreBoard from "./TennisScoreBoard";

const MarketAnalysisMatchOdd = ({
  eventDetails,
  matchOdds,
  bookData,
  scoreboardData,
  timeLeft
}) => {
  let game_type = 0;
  let eventName = "";
  let cat_rnr1 = "";
  let cat_rnr2 = "";
  let cat_rnr3 = "NA";
  let eventStatus = "";
  let rate1 = 0;
  let rate2 = 0;
  let rate3 = 0;
  let rate4 = 0;
  let rate5 = 0;
  let rate6 = 0;
  let rate7 = 0;
  let rate8 = 0;
  let rate9 = 0;
  let rate10 = 0;
  let rate11 = 0;
  let rate12 = 0;
  let rate13 = 0;
  let rate14 = 0;
  let rate15 = 0;
  let rate16 = 0;
  let rate17 = 0;
  let rate18 = 0;

  let r1b3 = 0;
  let r1b2 = 0;
  let r1b = 0;
  let r1l = 0;
  let r1l2 = 0;
  let r1l3 = 0;

  let r2b3 = 0;
  let r2b2 = 0;
  let r2b = 0;
  let r2l = 0;
  let r2l2 = 0;
  let r2l3 = 0;

  let r3b3 = 0;
  let r3b2 = 0;
  let r3b = 0;
  let r3l = 0;
  let r3l2 = 0;
  let r3l3 = 0;

  if (eventDetails !== null && eventDetails !== undefined) {
    eventName = eventDetails.evt_evt;
    cat_rnr1 = eventDetails.cat_rnr1;
    cat_rnr2 = eventDetails.cat_rnr2;
    cat_rnr3 = eventDetails.cat_rnr3;
    game_type = eventDetails.game_type;
    eventStatus = eventDetails.evt_status;
  }

  if (matchOdds !== null && matchOdds !== undefined) {
    //debugger;
    // runner1
    r1b = matchOdds.r1b;
    r1b2 = matchOdds.r1b2;
    r1b3 = matchOdds.r1b3;
    r1l = matchOdds.r1l;
    r1l2 = matchOdds.r1l2;
    r1l3 = matchOdds.r1l3;

    rate1 = matchOdds.rate1;
    rate2 = matchOdds.rate2;
    rate3 = matchOdds.rate3;
    rate4 = matchOdds.rate4;
    rate5 = matchOdds.rate5;
    rate6 = matchOdds.rate6;

    //runner2
    r2b = matchOdds.r2b;
    r2b2 = matchOdds.r2b2;
    r2b3 = matchOdds.r2b3;
    r2l = matchOdds.r2l;
    r2l2 = matchOdds.r2l2;
    r2l3 = matchOdds.r2l3;

    rate7 = matchOdds.rate7;
    rate8 = matchOdds.rate8;
    rate9 = matchOdds.rate9;
    rate10 = matchOdds.rate10;
    rate11 = matchOdds.rate11;
    rate12 = matchOdds.rate12;

    // runner3
    r3b = matchOdds.r3b;
    r3b2 = matchOdds.r3b2;
    r3b3 = matchOdds.r3b3;
    r3l = matchOdds.r3l;
    r3l2 = matchOdds.r3l2;
    r3l3 = matchOdds.r3l3;

    rate13 = matchOdds.rate13;
    rate14 = matchOdds.rate14;
    rate15 = matchOdds.rate15;
    rate16 = matchOdds.rate16;
    rate17 = matchOdds.rate17;
    rate18 = matchOdds.rate18;
  }

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };
  //console.log("bookData->", bookData);
  const { marketId } = useParams();
  return (
    <div style={{ background: "#e4e5e6" }}>
      <div>
        <div
          className="card card-accent-success"
          style={{
            marginBottom: "0px",
            borderTopColor: "#21a8d8",
            borderTopWidth: "2px"
          }}
        >
          <div
            className="card-header"
            style={{
              background: "#f1f3f5",
              padding: "7px 7px 4px 7px",
              border: "0px"
            }}
          >
            <h4 style={{ fontSize: "1.3125rem" }}>
              <strong
                className="site_family"
                style={{ fontSize: "1.1rem", paddingLeft: "5px" }}
              >
                {eventName} - Match Odds{" "}
              </strong>
              <span
                style={{ color: "rgb(232, 62, 140)" }}
                className="site_family"
              >
                <strong style={{ fontSize: "1.1rem", paddingLeft: "7px" }}>
                  {" "}
                  {eventDetails.inplay === 1 ? "INPLAY" : eventStatus}
                </strong>
              </span>
              <a
                className="cursor-pointer"
                onClick={() => {
                  const width = 1200;
                  const height = 560;
                  const left = window.screenX + (window.outerWidth - width) / 2;
                  const top =
                    window.screenY + (window.outerHeight - height) / 2;

                  window.open(
                    `/agent/user-book/${marketId}/1`,
                    "UserBookWindow",
                    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
                  );
                }}
              >
                <i className="fa fa-address-book"></i>
              </a>
            </h4>
          </div>
        </div>

        <div
          style={{
            background: "white",
            padding: "0px",
            border: "solid 1px #c7cdd4"
          }}
        >
          <div
            className="tb-content"
            style={{ padding: "0px", background: "white" }}
          >
            <div
              style={{ display: game_type == 1 ? "" : "none", padding: "4px" }}
            >
              <CricketScoreBoard
                eventDetails={eventDetails}
                scoreboardData={scoreboardData}
              ></CricketScoreBoard>
            </div>
            <div style={{ display: game_type == 2 ? "" : "none" }}>
              <FootBallScoreBoard></FootBallScoreBoard>
            </div>

            <div style={{ display: game_type == 3 ? "" : "none" }}>
              <TennisScoreBoard
                eventDetails={eventDetails}
                scoreboardData={scoreboardData}
              ></TennisScoreBoard>
            </div>

            <div style={{ margin: "8px 5px" }}>
              <div class="row bg-gray-100 market-head">
                <div class="col">
                  <strong className="site_family">
                    {" "}
                    {moment
                      .utc(eventDetails.evt_od)
                      .local()
                      .format("MMM D hh:mm a")}
                  </strong>
                </div>{" "}
                <div class="col text-right site_family">
                  <strong>{timeLeft}</strong>
                </div>
              </div>

              <div class="row runners">
                <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
                  <strong style={{ fontSize: "1rem" }} className="site_family">
                    {cat_rnr1}
                  </strong>{" "}
                  <br />{" "}
                  <span>
                    <span class="position-plus site_family">
                      <strong
                        style={{
                          color:
                            parseInt(bookData?.rnr1s) * -1 >= 0
                              ? "green"
                              : "red",
                          display:
                            bookData == undefined || bookData?.rnr1s == ""
                              ? "none"
                              : ""
                        }}
                      >
                        {" "}
                        {formatTruncate(
                          Math.round((bookData?.rnr1s || 0) * -1)
                        )}
                      </strong>
                    </span>{" "}
                  </span>{" "}
                </div>{" "}
                <div class="col-5 col-md-8 price">
                  <div class="row">
                    <div class="col-md-2 d-none d-md-block cta-back">
                      <div id="b3-54600" class="col-12 price site_family">
                        {r1b3}
                      </div>{" "}
                      <div id="bs3-54600" class="col-12 size site_family">
                        {rate3}
                      </div>
                    </div>{" "}
                    <div class="col-md-2 d-none d-md-block cta-back">
                      <div
                        id="b2-54600"
                        class="col-md-12 col-sm-12 price site_family"
                      >
                        {r1b2}
                      </div>{" "}
                      <div
                        id="bs2-54600"
                        class="col-md-12 col-sm-12 size site_family"
                      >
                        {rate2}
                      </div>
                    </div>{" "}
                    <div class="col-6 col-md-2 cta-back">
                      <div
                        id="b1-54600"
                        class="col-12 price site_family"
                        style={{ backgroundColor: "rgb(227, 248, 255)" }}
                      >
                        {r1b}
                      </div>{" "}
                      <div
                        id="bs1-54600"
                        class="col-12 size site_family"
                        style={{ backgroundColor: "rgb(227, 248, 255)" }}
                      >
                        {rate1}
                      </div>
                    </div>{" "}
                    <div class="col-6 col-md-2 cta-lay">
                      <div
                        id="l1-54600"
                        class="col-md-12 col-sm-12 price site_family"
                        style={{ backgroundColor: "rgb(255, 205, 204)" }}
                      >
                        {r1l}
                      </div>{" "}
                      <div
                        id="ls1-54600"
                        class="col-md-12 col-sm-12 size site_family"
                        style={{ backgroundColor: "rgb(255, 205, 204)" }}
                      >
                        {rate4}
                      </div>
                    </div>{" "}
                    <div class="col-md-2 d-none d-md-block cta-lay">
                      <div
                        id="l2-54600"
                        class="col-md-12 col-sm-12 price site_family"
                      >
                        {r1l2}
                      </div>{" "}
                      <div
                        id="ls2-54600"
                        class="col-md-12 col-sm-12 size site_family"
                      >
                        {rate5}
                      </div>
                    </div>{" "}
                    <div class="col-md-2 d-none d-md-block cta-lay">
                      <div
                        id="l3-54600"
                        class="col-md-12 col-sm-12 price site_family"
                      >
                        {r1l3}
                      </div>{" "}
                      <div
                        id="ls3-54600"
                        class="col-md-12 col-sm-12 size site_family"
                      >
                        {rate6}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={
                  cat_rnr3 == "NA"
                    ? "row runners lastItemBorder"
                    : "row runners"
                }
              >
                <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
                  <strong style={{ fontSize: "1rem" }} className="site_family">
                    {cat_rnr2}
                  </strong>{" "}
                  <br />{" "}
                  <span>
                    <span class="position-plus site_family">
                      <strong
                        style={{
                          color:
                            parseInt(bookData?.rnr2s) * -1 >= 0
                              ? "green"
                              : "red",
                          display:
                            bookData == undefined || bookData?.rnr2s == ""
                              ? "none"
                              : ""
                        }}
                      >
                        {" "}
                        {formatTruncate(Math.round(bookData?.rnr2s * -1))}
                      </strong>
                    </span>{" "}
                  </span>{" "}
                </div>{" "}
                <div class="col-5 col-md-8 price">
                  <div class="row">
                    <div class="col-md-2 d-none d-md-block cta-back">
                      <div id="b3-54600" class="col-12 price site_family">
                        {r2b3}
                      </div>{" "}
                      <div id="bs3-54600" class="col-12 size site_family">
                        {rate9}
                      </div>
                    </div>{" "}
                    <div class="col-md-2 d-none d-md-block cta-back">
                      <div
                        id="b2-54600"
                        class="col-md-12 col-sm-12 price site_family"
                      >
                        {r2b2}
                      </div>{" "}
                      <div
                        id="bs2-54600"
                        class="col-md-12 col-sm-12 size site_family"
                      >
                        {rate8}
                      </div>
                    </div>{" "}
                    <div class="col-6 col-md-2 cta-back">
                      <div
                        id="b1-54600"
                        class="col-12 price site_family"
                        style={{ backgroundColor: "rgb(227, 248, 255)" }}
                      >
                        {r2b}
                      </div>{" "}
                      <div
                        id="bs1-54600"
                        class="col-12 size site_family"
                        style={{ backgroundColor: "rgb(227, 248, 255)" }}
                      >
                        {rate7}
                      </div>
                    </div>{" "}
                    <div class="col-6 col-md-2 cta-lay">
                      <div
                        id="l1-54600"
                        class="col-md-12 col-sm-12 price site_family"
                        style={{ backgroundColor: "rgb(255, 205, 204)" }}
                      >
                        {r2l}
                      </div>{" "}
                      <div
                        id="ls1-54600"
                        class="col-md-12 col-sm-12 size site_family"
                        style={{ backgroundColor: "rgb(255, 205, 204)" }}
                      >
                        {rate10}
                      </div>
                    </div>{" "}
                    <div class="col-md-2 d-none d-md-block cta-lay">
                      <div
                        id="l2-54600"
                        class="col-md-12 col-sm-12 price site_family"
                      >
                        {r2l2}
                      </div>{" "}
                      <div
                        id="ls2-54600"
                        class="col-md-12 col-sm-12 size site_family"
                      >
                        {rate11}
                      </div>
                    </div>{" "}
                    <div class="col-md-2 d-none d-md-block cta-lay">
                      <div
                        id="l3-54600"
                        class="col-md-12 col-sm-12 price site_family"
                      >
                        {r2l3}
                      </div>{" "}
                      <div
                        id="ls3-54600"
                        class="col-md-12 col-sm-12 size site_family"
                      >
                        {rate12}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {cat_rnr3 !== "NA" ? (
                <div class="row runners lastItemBorder">
                  <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
                    <strong
                      style={{ fontSize: "1rem" }}
                      className="site_family"
                    >
                      {cat_rnr3}
                    </strong>{" "}
                    <br />{" "}
                    <span>
                      <span class="position-plus site_family">
                        <strong
                          style={{
                            color:
                              parseInt(bookData?.rnr3s) * -1 >= 0
                                ? "green"
                                : "red",
                            display:
                              bookData == undefined || bookData?.rnr3s == ""
                                ? "none"
                                : ""
                          }}
                        >
                          {" "}
                          {formatTruncate(
                            Math.round((bookData?.rnr3s || 0) * -1)
                          )}
                        </strong>
                      </span>{" "}
                    </span>{" "}
                  </div>{" "}
                  <div class="col-5 col-md-8 price">
                    <div class="row">
                      <div class="col-md-2 d-none d-md-block cta-back">
                        <div id="b3-54600" class="col-12 price site_family">
                          {r3b3}
                        </div>{" "}
                        <div id="bs3-54600" class="col-12 size site_family">
                          {rate15}
                        </div>
                      </div>{" "}
                      <div class="col-md-2 d-none d-md-block cta-back">
                        <div
                          id="b2-54600"
                          class="col-md-12 col-sm-12 price site_family"
                        >
                          {r3b2}
                        </div>{" "}
                        <div
                          id="bs2-54600"
                          class="col-md-12 col-sm-12 size site_family"
                        >
                          {rate14}
                        </div>
                      </div>{" "}
                      <div class="col-6 col-md-2 cta-back">
                        <div
                          id="b1-54600"
                          class="col-12 price site_family"
                          style={{ backgroundColor: "rgb(227, 248, 255)" }}
                        >
                          {r3b}
                        </div>{" "}
                        <div
                          id="bs1-54600"
                          class="col-12 size site_family"
                          style={{ backgroundColor: "rgb(227, 248, 255)" }}
                        >
                          {rate13}
                        </div>
                      </div>{" "}
                      <div class="col-6 col-md-2 cta-lay">
                        <div
                          id="l1-54600"
                          class="col-md-12 col-sm-12 price site_family"
                          style={{ backgroundColor: "rgb(255, 205, 204)" }}
                        >
                          {r3l}
                        </div>{" "}
                        <div
                          id="ls1-54600"
                          class="col-md-12 col-sm-12 size site_family"
                          style={{ backgroundColor: "rgb(255, 205, 204)" }}
                        >
                          {rate16}
                        </div>
                      </div>{" "}
                      <div class="col-md-2 d-none d-md-block cta-lay">
                        <div
                          id="l2-54600"
                          class="col-md-12 col-sm-12 price site_family"
                        >
                          {r3l2}
                        </div>{" "}
                        <div
                          id="ls2-54600"
                          class="col-md-12 col-sm-12 size site_family"
                        >
                          {rate17}
                        </div>
                      </div>{" "}
                      <div class="col-md-2 d-none d-md-block cta-lay">
                        <div
                          id="l3-54600"
                          class="col-md-12 col-sm-12 price site_family"
                        >
                          {r3l3}
                        </div>{" "}
                        <div
                          id="ls3-54600"
                          class="col-md-12 col-sm-12 size site_family"
                        >
                          {rate18}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            <div>
              <div
                style={{
                  borderTop: "1px solid lightgray",
                  margin: "0px 5px",
                  borderBottom: "1px solid lightgray",
                  padding: "5px",
                  display: game_type != 1 ? "" : "none"
                }}
              >
                <p
                  style={{
                    textAlign: "left",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "16px",
                    fontWeight: "inherit",
                    color: "red"
                  }}
                >
                  <b>LIVE VIDEO AVAILABLE</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketAnalysisMatchOdd;